<template>
	<div>
		<draggable class="drag-container" animation="300" v-bind="draggableOptions" v-model="paper.questionsList" @sort="changeSort">
			<transition-group tag="div" type="transition" :name="'flip-list'">
				<div
					:name="`name${item.qid}`"
					:gutter="10"
					:id="index"
					class="item_container"
					:class="{ item_container_hover: item.isedit }"
					v-for="(item, index) in paper.questionsList"
					:key="item.qid"
					:ref="item.qid"
				>
					<div class="border-none">
						<!-- 手机号 单行、多行输入框 填空题 -->
						<QuestionBlank
							:ref="`ques${item.qid}`"
							v-if="item.questionsTypeId == 2 || item.questionsTypeId == 3 || item.questionsTypeId == 4 || item.questionsTypeId == 5"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex(index)"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 单项选择题 -->
						<QuestionSingle2
							v-else-if="item.questionsTypeId == 8"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:questionList="paper.questionsList"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@wjsetquestionoption="wjsetquestionoption"
							@questionCopy="questionCopy"
						/>

						<!-- 多项选择 -->
						<QuestionMult2
							v-else-if="item.questionsTypeId == 10"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:questionList="paper.questionsList"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@wjsetquestionoption="wjsetquestionoption"
							@questionCopy="questionCopy"
						/>

						<!-- 判断题 -->
						<QuestionJudge
							v-else-if="item.questionsTypeId == 12"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 下拉框 -->
						<QuestionDropDownBox
							v-model="value1"
							v-else-if="item.questionsTypeId == 9"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							:questionList="paper.questionsList"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 多项填空 -->
						<QuestionMu
							v-model="value1"
							v-else-if="item.questionsTypeId == 35"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 图片选择 -->
						<QuestionImage
							v-model="value1"
							v-else-if="item.questionsTypeId == 6"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 星级评分 -->
						<QuestionRate
							ref="setImg"
							v-else-if="item.questionsTypeId == 11"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							:imageUrl="imageUrl"
							:tipsObj="tipsObj"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 日期选择 -->
						<QuestionDate
							v-model="value1"
							v-else-if="item.questionsTypeId == 13"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 排序题 -->
						<QuestionSort
							v-model="value1"
							v-else-if="item.questionsTypeId == 14"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 地址位置 -->
						<QuestionAddress
							v-model="value1"
							v-else-if="item.questionsTypeId == 15"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 城市选择 -->
						<QuestionCity
							v-model="value1"
							v-else-if="item.questionsTypeId == 16"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 矩阵单选 -->
						<QuestionRectSingle
							v-else-if="item.questionsTypeId == 19"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
							@questionCopy="questionCopy"
						/>
						<!-- 矩阵多选 -->
						<QuestionRectMult
							v-else-if="item.questionsTypeId == 20"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
							@questionCopy="questionCopy"
						/>
						<!-- 矩阵星级评分 -->
						<QuestionMatrixRate
							v-else-if="item.questionsTypeId == 21"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
							@questionCopy="questionCopy"
						/>
						<!-- 矩阵填空 -->
						<QuestionMatrixBlank
							v-else-if="item.questionsTypeId == 22"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
							@questionCopy="questionCopy"
						/>
						<!-- 段落标题 -->
						<QuestionParagraph 
							v-else-if="item.questionsTypeId == 25" 
							:index="index" 
							:question="item" 
							@questiondel="questiondel" 
							@setEditIndex="setEditIndex"
							@jumpshow="jumpshow" 
							@questionCopy="questionCopy"
						/>
						<!-- 分页 -->
						<QuestionPaging
							v-else-if="item.questionsTypeId == 26"
							:index="index"
							:question="item"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@questionCopy="questionCopy"
						/>
						<!-- 上传文件 -->
						<QuestionUploadFile
							v-else-if="item.questionsTypeId == 33"
							:bankList="bankList"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@getBankList="getBankList"
							@delFormBank="delFormBank"
							@addToBank="addToBank"
							@addBank="addBank"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@questionCopy="questionCopy"
						/>
					</div>
					<!-- 时间选择 -->
					<QuestionTime
						v-model="value1"
						v-if="item.questionsTypeId == 17"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@questionCopy="questionCopy"
					/>
					<!-- 横向填空 -->
					<QuestionCrosswiseBlank
						v-else-if="item.questionsTypeId == 34"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@questionCopy="questionCopy"
					/>

					<QuestionCascadeCascading
						v-else-if="item.questionsTypeId == 36"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@questionCopy="questionCopy"
					/>
					<QuestionProportion
						v-else-if="item.questionsTypeId == 37"
						v-model="value1"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@wjdelquestionoption="wjdelquestionoption"
						@wjaddquestionoption="wjaddquestionoption"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@questionCopy="questionCopy"
					/>
					
					
					<!-- 量表 -->
					<QuestionScale
						ref="setImg"
						v-else-if="item.questionsTypeId == 38"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						:editIndex="editIndex"
						:editOptionIndex="editOptionIndex"
						:imageUrl="imageUrl"
						:tipsObj="tipsObj"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@questionCopy="questionCopy"
					/>
					<!-- 多维表格 --> 
				
					<QuestionMultidimensionalTable
						v-else-if="item.questionsTypeId == 39"
						:bankList="bankList"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@getBankList="getBankList"
						@delFormBank="delFormBank"
						@addToBank="addToBank"
						@addBank="addBank"
						@deleteOptionColumn="deleteOptionColumn"
						@wjaddquestionoption="wjaddquestionoption"
						@wjdelquestionoption="wjdelquestionoption"
						@wjsetquestionoption="wjsetquestionoption"
						@questiondel="questiondel"
						@jumpshow="jumpshow"
						@setEditIndex="setEditIndex"
						@setEditOptionIndex="setEditOptionIndex"
						@addRows="addRows"
						@addColumn="addColumn"
						@batchAddRows="batchAddRows"
						@batchAddColumns="batchAddColumns"
						@questionCopy="questionCopy"
					/>
				</div>
			</transition-group>
		</draggable>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import QuestionBlank from './QuestionBlank';
import QuestionSingle2 from './QuestionSingle2';
import QuestionMult2 from './QuestionMult2';
import QuestionJudge from './QuestionJudge';
import QuestionMu from './QuestionMu';
import QuestionDropDownBox from './QuestionDropDownBox';
import QuestionImage from './QuestionImage';
import QuestionRate from './QuestionRate';
import QuestionScale from './QuestionScale';

import QuestionDate from './QuestionDate';
import QuestionSort from './QuestionSort';
import QuestionAddress from './QuestionAddress';
import QuestionCity from './QuestionCity';
import QuestionRectSingle from './QuestionRectSingle';
import QuestionRectMult from './QuestionRectMult';
import QuestionMatrixRate from './QuestionMatrixRate';
import QuestionMatrixBlank from './QuestionMatrixBlank';
import QuestionParagraph from './QuestionParagraph';
import QuestionPaging from './QuestionPaging';
import QuestionUploadFile from './QuestionUploadFile';
import QuestionTime from './QuestionTime';
import QuestionCrosswiseBlank from './QuestionCrosswiseBlank';
import QuestionCascadeCascading from './QuestionCascadeCascading';
import QuestionProportion from './QuestionProportion';
import QuestionMultidimensionalTable from './QuestionMultidimensionalTable';
import Paper from '../../js/Paper';
import { logicalSettings } from '../../js/logicalSettings';
// import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import { v1 as UUID } from 'uuid';
// import questionGap from "./questionGap.vue"
// import questionMore from "./questionMore.vue"
// import questionSingle from "./questionSingle.vue"
import { mapState } from 'vuex';
// import Paper from "@/components/examQuesTemplate/js/Paper.js"
export default {
	name: 'questionnaireQuesTemplate',
	components: {
		draggable,
		QuestionBlank,
		QuestionSingle2,
		QuestionMult2,
		QuestionJudge,
		QuestionDropDownBox,
		QuestionMu,
		QuestionImage,
		QuestionRate,
		QuestionScale,
		QuestionDate,
		QuestionSort,
		QuestionAddress,
		QuestionCity,
		QuestionRectSingle,
		QuestionRectMult,
		QuestionMatrixRate,
		QuestionMatrixBlank,
		QuestionParagraph,
		QuestionPaging,
		QuestionUploadFile,
		QuestionTime,
		QuestionCrosswiseBlank,
		QuestionCascadeCascading, //级联题
		QuestionProportion, // 比重题
		QuestionMultidimensionalTable,//多维表格
		// TitleEditor,
		// questionSingle,
		// questionGap,
		// questionMore,
	},
	props: {
		tipsObj: { type: Object },
		imageUrl: { type: Object },
		editOptionIndex: { type: String, default: '0_0' },
		paper: {
			type: Object,
			default: () => {}
		},
		editIndex: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除 其余不能操作试题
		isBankViewTest: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			// draggableOptions: {
			// 	handle: '.handle'
			// },
			inputHeightList: ['小', '中', '大'],
			formatList: [
				{
					value: 0,
					label: '不限'
				},
				{
					value: 1,
					label: '文本'
				},
				{
					value: 2,
					label: '数字'
				},
				{
					value: 3,
					label: '字母'
				},
				{
					value: 4,
					label: '中文'
				},
				{
					value: 5,
					label: 'Email'
				},
				{
					value: 6,
					label: '手机号码'
				},
				{
					value: 7,
					label: '网址'
				},
				{
					value: 8,
					label: '身份证'
				}
			],
			bankList: [],
			value1: '',
			draggableOptions: {
				handle: '.drag-handle'
			},
		};
	},
	computed: {
		...mapState(['wjQuestionTypeArr', 'examQuestionTypeArr'])
	},
    created() {
        this.getBankList()
    },
    methods: {
		questionCopy(question){
			this.$emit('wjQuestionCopy',question)
		},
        // 题目重新排序
        changeSort() {
        // console.log(this.paper.questionsList)
        let pageNumber = 1
        let quesIndex = 0
        this.paper.questionsList.forEach((info, index) =>{
            // console.log(info.questionsTypeId)
            if(info.questionsTypeId == '26') {
                info.pageNumber = pageNumber++
            } else if (this.wjQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {       
                info.quesIndex = quesIndex++
            }
        })
        },
        addBank(e,qid) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankSave}`,
                method: "POST",
                data: e,
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        let paper = new Paper();
                        that.setPaperJson(res.message, paper,qid)
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        
        setPaperJson(id, paper, qid) {
            let that = this;
            let data = {
                id: id,
                paperjson: JSON.stringify(paper),
                bankType: 1
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankAddQuess}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        that.getBankList()
                        // console.log(that.$refs.quesTemplate1)
                        let ref = `ques${qid}`
                        // console.log(that.$refs[ref][0])
                        that.$refs[ref][0].cancelAddBank()
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        delFormBank(e) {
            console.log(e)
            let ids = [e.bqid]
            // let ids = [{
            //     bankId: e.bid,
            //     id: e.bqid
            // }]
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.examBankRecycleBinCancel}?ids=${ids}`,
                method: "GET",
                cb(res) {
                    if (res.code == '0') {
                        that.$message({
                            message: '取消收藏',
                            type: 'success'
                        });
                        e.bqid = ''
                        that.$emit('toGetQuestion')
                    } else {
                        that.$message.error('取消失败')
                    }
                },
            };
            this.$util.request(params);
        },
        addToBank(e,id) {
            // 未改
            // this.$set(e, 'qid', UUID())
			let question = logicalSettings(JSON.parse(JSON.stringify(e)))
			let tageName = ''
			if(e.quesLabelName){
				tageName = e.quesLabelName.toString()
			}else{
				tageName = ''
			}
            this.$set(e, 'bid', id)
            let that = this;
            let data = {
                quesName: question.questionsName,
                bid: id,
                quesJson: JSON.stringify(question),
				tageName: tageName
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankUpdateQues}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        that.$set(e, 'bqid', res.message)
                        that.$message({
                            message: '收藏成功',
                            type: 'success'
                        });
						console.log(res.message)
						console.log(e.bqid)
                    } else {
                        e.bqid = ''
                        e.bid = ''
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        getBankList() {
            let that = this
            let data = this.$qs.stringify({
                'isSystem': 0, // 0自建题库 1系统题库
                'pageIndex': 1,
                'pageSize': 10000,
                'bankType': 1
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankList}?${data}`,
                method: "GET",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        that.bankList = res.resultBody.datas
                    } else {
						that.bankList = []
					}
                },
            };
            this.$util.request(params);
        },
        // 删除题 删除行
        questiondel(qid, SonId, associated) {
            this.$emit('questiondel', qid, SonId, associated)
        },
        // 逻辑设置弹窗
        jumpshow(question) {
            this.$emit('jumpshow', question)
        },
        setEditIndex(index) {
            this.$emit('setEditIndex', index)
        },
        setEditOptionIndex(childIndex) {
            this.$emit('setEditOptionIndex', childIndex)
        },
        wjaddquestionoption(qid, Arr, qType, haveInput){
            this.$emit('wjaddquestionoption', qid, Arr, qType, haveInput)
        },
        wjdelquestionoption(obj, index) {
            this.$emit('wjdelquestionoption', obj, index)
        },
        wjsetquestionoption(question, option, index, type) {
            this.$emit('wjsetquestionoption', question, option, index, type)
        },
        addRows(text) {
            this.$emit('addRows', text)
        },
        addColumn(text) {
            this.$emit('addColumn', text)
        },
        batchAddRows(arr) {
            this.$emit('batchAddRows', arr)
        },
        batchAddColumns(arr) {
            this.$emit('batchAddColumns', arr)
        },
        
        deleteOptionColumn(obj) {
            this.$emit('deleteOptionColumn', obj)
        },
        // submit(state) {
        //     this.$emit('submit', state)
        // }

    }
}
</script>

<style scoped lang="scss">
.box-all-active {
	border: 1px solid #169bd5;
}

.box-all {
	line-height: 30px;
	margin-bottom: 5px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	border-radius: 4px;
	outline: none;
	box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
}
.content-box {
	background-color: rgb(255, 255, 255);
}
.content {
	padding: 0 10px;
}
.box {
	display: flex;
	justify-content: space-between;
}
.box-f {
	width: 80%;
	font-size: 16px;
	font-weight: bold;
	display: flex;
}
.box-f span {
	padding-right: 15px;
}
.box-icon i {
	padding-left: 20px;
}
.box-c,
.box-d {
	padding-left: 22px;
}
.el-container {
	font-size: 14px;
}
.title {
	margin: 10px 0;
}

.tip {
	color: #999;
	font-size: 14px;
	padding-left: 10px;
}
.el-main {
	background-color: #eee;
}
.submit-exam {
	width: 100%;
	margin-top: 20px;
}
.edid-box {
	margin-top: 10px;
	border-top: 1px solid #999;
	font-size: 14px;
	/* height: 400px; */
	padding-bottom: 20px;
}
.title-h4 {
	padding-left: 30px;
}

.subject-box {
	width: 380px;
	line-height: 60px;
	margin: 0 auto;
}
.subject {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #999;
	align-items: center;
}
.placeholder-input {
	width: 64%;
}
.exam-title {
	display: inline-block;
}
.exam-title,
.outline-none {
	outline: none;
	max-width: 73%;
	margin-top: 5px;
}
</style>
<style lang="scss">
.dropdown-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	.btn {
		margin-left: 10px;
	}
}
.to-bank {
	color: #424542;
}
.my-bank-tag {
	display: inline-block;
	box-sizing: border-box;
	padding: 1px 6px;
	background: rgba(38, 114, 255, 0.08);
	color: rgba(38, 114, 255, 0.7);
	font-size: 12px;
	line-height: 1.5;
}
.setBtn-box {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>
